import { Component, OnInit } from '@angular/core';
import { Errors, FooterService, LocalService } from '../../../core';

@Component({
  selector: 'app-open-house-quiz',
  templateUrl: './open-house-quiz.component.html',
  styleUrls: ['./open-house-quiz.component.scss']
})
export class OpenHouseQuizComponent implements OnInit {
  errors: Errors = { errors: {} };
  userData: any;
  lang!: string;
  switchRole: any;
  accessToken: any;
  getSelectedChallengename: any;
  isQuizValid!: boolean;
  isCanUserView!: boolean;
  isDataReceived1: boolean = false;
  isDataReceived2: boolean = false;

  constructor(
    private footerService: FooterService,
  ) { }

  ngOnInit() {
    this.lang = localStorage.getItem('selectedLanguage') as string;
    this.userData = LocalService.get('userProfile');
    this.getSelectedChallengename = localStorage.getItem('setSelectedChallengename');
    if (this.getSelectedChallengename != null) {
      if (this.getSelectedChallengename.includes('Partners Open House Tour')) {
        this.switchRole = 'manager';
      } if (this.getSelectedChallengename.includes('Sellers Open House Tour')) {
        this.switchRole = 'seller';
      }
    } else {
      this.switchRole = localStorage.getItem('selectedRole');
    }
    this.checkQuizValidity();
    this.getBannerWidget();
    this.checkUserCanAccessQuiz();
  }

  getBannerWidget() {
    this.footerService.getBannerWidgetapi().subscribe((data: any) => {
      this.accessToken = data.accessToken;
      this.isDataReceived1 = true;
    }, (err: any) => {
      this.errors = err;
    });
  }

  checkUserCanAccessQuiz() {
    this.footerService.checkUserCanAccessQuiz().subscribe((data: any) => {
      this.isCanUserView = data.canView;
      this.isDataReceived2 = true;
    }, (err: any) => {
      this.errors = err;
    });
  }

  checkQuizValidity() {
    const today = new Date();
    const startDate = new Date('11/02/2020');
    const endDate = new Date('11/17/2020');
    if (today.getTime() <= endDate.getTime() && today.getTime() >= startDate.getTime()) {
      this.isQuizValid = true;
    } else {
      this.isQuizValid = false;
    }
  }

  goBack() {
    window.history.go(-1);
  }

}
